"use client";

import Link from "next/link";
import { Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { DocsSidebar } from "./DocsSidebar";
import { DocsSearch } from "./DocsSearch";

export function DocsHeader() {
  return (
    <header className="sticky top-0 z-30 flex items-center gap-2 sm:gap-4 border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 px-4 h-14 lg:px-6">
      {/* Mobile sidebar trigger */}
      <Sheet>
        <SheetTrigger asChild>
          <Button variant="ghost" size="icon" className="lg:hidden">
            <Menu className="h-5 w-5" />
            <span className="sr-only">Toggle sidebar</span>
          </Button>
        </SheetTrigger>
        <SheetContent side="left" className="w-72 p-0">
          <div className="pt-14">
            <DocsSidebar />
          </div>
        </SheetContent>
      </Sheet>

      {/* Logo */}
      <Link href="/" prefetch={false} className="flex items-center gap-2 font-semibold">
        Volume Reach
      </Link>

      <span className="hidden sm:inline text-muted-foreground text-sm">/</span>
      <Link
        href="/docs"
        className="hidden sm:inline text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
      >
        Docs
      </Link>

      <div className="flex-1" />

      <DocsSearch />

      <Link href="/login?mode=register">
        <Button size="sm">Get Started</Button>
      </Link>
    </header>
  );
}
